import React from "react";
import { Typography, Stack, IconButton, Box } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useHistory } from "react-router-dom";
import DoneIcon from "@mui/icons-material/Done";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import SearchIcon from "@mui/icons-material/Search";
import Balance from "../Balance";
import { useTranslation } from "react-i18next";
import VerificationSVG from './../../assets/common/artistProfile/Verification.svg';
export default function PageHeader(props) {
  const { t } = useTranslation("common");
  const history = useHistory();
  return (
    <Stack
      direction="row"
      align="center"
      justifyContent="space-between"
      alignItems="center"
      sx={{ height: "5vh" }}
    >
      {props["noBack"] ? null : (
        <Box
          sx={{ color: "#999999", display: "flex", alignItems: "center" }}
          className="_cp fs-14"
          onClick={() =>
            props["save"]
              ? props.onDiscard()
              : props["close"]
              ? props.onClose()
              : history.goBack()
          }
        >
          <ArrowBackIosIcon className="fs-14" sx={{ color: "#999999" }} />{" "}
          {t("back")}
        </Box>
      )}
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ margin: "auto" }}
      >
        <Typography
          align="center"
          sx={{ fontWeight: "bold !important", margin: "auto !important" }}
        >
          {props.title}
        </Typography>
        {props["isVerified"] ? (
          <img
          src={VerificationSVG}
          alt="Verified"
          style={{
            border: "0px solid #FFEE20",
            borderRadius: "50%",
            width: "22px",   // Adjust width as needed
            height: "22px",  // Adjust height as needed
            padding: "2px"   // Adjust padding as needed
            }}
          />
        ) : null}
      </Stack>
      {props["save"] ? (
        <IconButton onClick={() => props.onSave()}>
          <DoneIcon className="_cp" color="default" />
        </IconButton>
      ) : props["clear"] ? (
        <IconButton onClick={() => props.onClear()}>
          <ClearAllIcon className="_cp" color="default" />
          <Typography component="span" variant="body2">
            Clear all
          </Typography>
        </IconButton>
      ) : props["balance"] ? (
        <Balance />
      ) : props["close"] ? (
        <IconButton onClick={() => history.goBack()}>
          <CloseIcon className="_cp" color="default" />
        </IconButton>
      ) : props["more"] ? (
        <IconButton onClick={() => props.onClick()}>
          <MoreVertIcon className="_cp" color="default" />
        </IconButton>
      ) : props["search"] ? (
        <IconButton>
          <SearchIcon
            sx={{ fontSize: "26px" }}
            className="_cp"
            color="default"
          />
        </IconButton>
      ) : null}
    </Stack>
  );
}
